import { connect } from 'react-redux'
import AnalysisBox from './AnalysisBox'

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

const AnalysisBoxContainer = connect(
    mapStateToProps,
)(AnalysisBox)

export default AnalysisBoxContainer
